/** The signing-flow step preceding autopay setup, skipping down payment when none is required. */
function getAutopayBackRoute(finalizeData) {
    return finalizeData?.downPaymentRequired ? '/down-payment' : '/autopay';
}
export default getAutopayBackRoute;
